// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	PackagePackageNameListItem: 'package-package-name-list-item',
	Dropdown: 'dropdown',
	DocListItem: 'doc-list-item',
	Button: 'button',
	Button1: 'button-1',
	ExportAsPdfButton: 'export-as-pdf-button',
	Button2: 'button-2',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
